<template>
  <div class="commit-report">
    <div class="reason-scroll">
      <div class="guide-tip">-
        <span>{{ guideTip }}</span>
      </div>
      <p class="guide-orderList" v-if="isHastradingorder">
        <Icon name="bulb-o" color="red" class="icon" />
        系统识别出您与对方的订单暂未确认收货，在举报的同时您可以通过【申请退货退款】来挽回损失。<span
          @click="jumpTo()"
          >点击进入订单列表</span
        >&nbsp;选择相应订单进入并操作。如遇问题，可到【我的-客服中心】寻求帮助
      </p>
      <section v-if="isChatHistoryEnabled" class="chat-history-proof">
        <header>聊天证据</header>
      </section>
      <section class="process-desc">
        <header>过程描述</header>
        <textarea
          id="desc"
          v-model="desc"
          :placeholder="descPlaceholder"
          maxlength="200"
        ></textarea>
        <span class="desc-length">{{ remainDescLength }}</span>
      </section>
      <section class="snapshot-proof">
        <header>截图凭证</header>
        <div class="snapshot-tip">{{ snapshotTip }}</div>
        <div class="upload-area">
          <z-upload
              v-model="imageFiles"
              accept="image/*"
              :process-file="processFile"
              :max="9"
              btnUploadInfo="上传图片"
            />
          <div class="empty" style="clear: both;"></div>
        </div>
      </section>
    </div>
    <!-- 下一步 -->
    <z-button-group>
      <z-button type="primary" :loading="loading" :disabled="isDisable" @click="submitReport">提交</z-button>
    </z-button-group>
  </div>
</template>

<script>
import compress from '@zz-common/zz-ui/lib/utils/image'
import { Icon, Upload, Button, ButtonGroup } from '@zz-common/zz-ui'
import setPicSize from '@zz-app/setPicSize'
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import { fkAddReport, hastradingorder } from '@api/resourceApi'

const MAX_DESC_LENGTH = 200

export default {
  name: 'CommitReport',
  inject:
  {
    sharedData: {
      default: () => {}
    },
    submitData: {
      default: () => {}
    },
    mergeSubmitData: {}
  },
  data() {
    return {
      desc: '', //描述文字
      descLength: 0, //描述文字长度
      imageFiles: [], //上传图片
      isHastradingorder: false, //交易记录
      loading: false //按钮加载状态
    }
  },
  // eslint-disable-next-line vue/no-unused-components
  components: {
    Icon,
    zUpload: Upload,
    zButton: Button,
    zButtonGroup: ButtonGroup
  },
  computed: {
    //记录字数数量
    remainDescLength() {
      return this.desc.length + '/' + MAX_DESC_LENGTH
    },
    //一些tips
    guideTip() {
      return '请上传能帮助我们锁定坏人的凭证'
    },
    descPlaceholder() {
      return '请尽可能详细描述您举报的原因及完整过程，以帮助我们快速定位'
    },
    snapshotTip() {
      return '请提供对方违规的有效凭证，以帮助我们快速定位。如对方引导您转转外沟通，可提供聊天记录截图等证据'
    },
    //历史记录
    isChatHistoryEnabled() {
      return false
    },
    //按钮禁用状态
    isDisable() {
      return !this.desc.length
    }
  },
  methods: {
    setPicSize,
    processFile(file, next) {
      // 开启图片压缩，提高上传的速度，同时修正拍摄的图片方向和显示的问题
      compress(file, {
        compress: true
      }, next)
    },
    //获取私信记录
    getLetterData() {
      if (this.submitData.chooseType === '2') {
        const msgIdList = this.submitData.chooseEvidence.slice(',')
        const letterList = JSON.parse(window.sessionStorage.getItem('letterList'))
        console.log('-----msgIdlist', msgIdList)
        console.log('-----letterList', letterList)
        const chooseLetterList = []
        letterList.forEach((item) => {
          if (msgIdList.indexOf(item.msgId) > -1) {
            const {
              content = '',
              userId = '',
              type = '',
              timeStamp = '',
              msgId = '',
              clientMsgId = ''
            } = item
            chooseLetterList.push({ msgId, content, userId, type, timeStamp, clientMsgId })
          }
        })
        this.mergeSubmitData({
          chooseEvidence: JSON.stringify(chooseLetterList)
        })
        window.sessionStorage.removeItem('letterList')
        const letterLists = JSON.parse(window.sessionStorage.getItem('letterList'))
        console.log('-----移除后的letterList', letterLists)
        console.log('-----chooseEvidence', this.chooseEvidence)
      }
    },
    //获取交易记录
    getHastradingorder() {
      return hastradingorder({
        toUid: this.sharedData.toUid
      })
        .then((res) => {
          console.log('---hastradingorder---', res)
          if (res == '1' && native.client !== 'zzseller') {
            this.isHastradingorder = true
          } else if (res == '0') {
            this.isHastradingorder = false
          }
          console.log('---isHastradingorder---', this.isHastradingorder)
          this.reportDetial = res
          return res
        })
        .catch((err) => {
          console.error(err)
          if (!err.errMsg) return
          this.$toast(err.errMsg)
        })
    },
    //跳转‘我买到的’
    jumpTo() {
      lego.send({
        pagetype: 'ZZUP_REPORT_COMMIT',
        actiontype: 'ORDER_LIST_CLICK'
      })
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/trade/order-list/buy.html',
        newPageTitle: '我买到的'
      })
    },
    //提交证据
    submitReport() {
      if (this.desc.length === 0) return this.$toast('请填写过程描述后再提交')
      lego.send({
        pagetype: 'ZZUP_REPORT_COMMIT',
        actiontype: 'SUBMIT_CLICK',
        backup: {
          from: this.submitData.from,
          reasonId: this.submitData.reasonId
        }
      })
      window.sessionStorage.removeItem(`reason_list${this.submitData.from}`)
      // const params = {
      //   toUid: this.beReportedUid,
      //   infoId: this.infoId,
      //   postId: this.postId,
      //   videoId: this.videoId,
      //   from: this.from,
      //   reasonId: this.reasonId,
      //   chooseEvidence: this.chooseEvidence,

      //   chooseType: this.chooseType,
      //   content: this.desc,
      //   pics: this.pics.join('|'),

      //   moneyLoss: this.reasonId === '201' ? this.moneyLoss : '',
      //   moneyLossPics: this.reasonId === '201' ? this.moneyLossPics : [],
      //   firstPayTime: this.reasonId === '201' ? this.firstPayTime : ''
      // }
      //合并全局提交数据
      this.mergeSubmitData({
        content: this.desc,
        pics: this.imageFiles.map(item => item.url).join('|')
      })
      this.loading = true;
      fkAddReport(this.submitData)
        .then((_data) => {
          this.loading = false
          this.$toast('提交成功')
          //  提交成功后 2s 关闭页面
          setTimeout(() => {
            native.close()
          }, 1000)
        })
        .catch((err) => {
          console.log('submiterror', err);
          this.loading = false
          //  提交失败后 2s 关闭页面
          setTimeout(() => {
            native.close()
          }, 1000)
        })
    }
  },
  mounted() {
    this.getHastradingorder()
    this.getLetterData()
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
